import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowUp } from 'react-icons/io';
import { FaMapMarker, FaPhone, FaEnvelope, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
const Footer: React.FC = () => (
  <footer className="ftco-footer ftco-section">
    <div className="container">
      <div className="row">
        <div className="mouse">
          <a href="#" className="mouse-icon">
            <div className="mouse-wheel">
              <IoIosArrowUp size={20} color="#FFFFFF" />
            </div>
          </a>
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-md">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">F.home - Fresh From Home</h2>
            <p>Farm to Home: pure, authentic, naturally produced foods sourced from farms and local farm communities, with no artificial colours, no preservatives, and no additives.</p>
            <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
              <li className="ftco-animate"><a href="#"><FaTwitter /></a></li>
              <li className="ftco-animate"><a href="https://www.facebook.com/share/194ez4Q11N/"><FaFacebook /></a></li>
              <li className="ftco-animate"><a href="https://www.instagram.com/f.home_freshfromhome?igsh=MWwwMDJuZ2V0emo2cA=="><FaInstagram /></a></li>
            </ul>
          </div>
        </div>
        <div className="col-md">
          <div className="ftco-footer-widget mb-4 ml-md-5">
            <h2 className="ftco-heading-2">Menu</h2>
            <ul className="list-unstyled">
              <li><Link to="/shop" className="py-2 d-block">Shop</Link></li>
              <li><Link to="/about" className="py-2 d-block">About</Link></li>
              <li style={{ display: 'none' }}><Link to="/blog" className="py-2 d-block">Journal</Link></li>
              <li><Link to="/contact" className="py-2 d-block">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="col-md-4">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Help</h2>
            <div className="d-flex">
              <ul className="list-unstyled mr-l-5 pr-l-3 mr-4">
                <li><Link to="/shipping-policy" className="py-2 d-block">Shipping Information</Link></li>
                <li><Link to="/return-policy" className="py-2 d-block">Returns &amp; Exchange</Link></li>
                <li><Link to="/terms-and-conditions" className="py-2 d-block">Terms &amp; Conditions</Link></li>
                <li><Link to="/privacy-policy" className="py-2 d-block">Privacy Policy</Link></li>
                <li><Link to="/data-deletion-policy" className="py-2 d-block">Data Deletion Policy</Link></li>
              </ul>
              <ul className="list-unstyled">
                <li><Link to="/refund-and-cancellation-policy" className="py-2 d-block">Refund Policy</Link></li>
                <li><Link to="/contact" className="py-2 d-block">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Have a Questions?</h2>
            <div className="block-23 mb-3">

              <ul>
                <li>
                  <FaMapMarker style={{ marginRight: "8px" }} />
                  <span className="text">PLOT NO:5,THIRUVALLUVAR STREET,NGGO NAGAR,THIRUKOVILUR,THIRUKOVILUR BLOCK VILUPPURAM,TAMILNADU-605757</span>
                </li><br/>
                <li>
                  <a href="#">
                    <FaPhone style={{ marginRight: "8px" }} />
                    <span className="text">+91 9148761750</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <FaEnvelope style={{ marginRight: "8px" }} />
                    <span className="text">care@fhome.shop</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <p>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright &copy;{new Date().getFullYear()} All rights reserved |<i className="icon-heart color-danger" aria-hidden="true"></i> by <a href="https://fhome.shop/" target="_blank" rel="noopener noreferrer">Fhome</a>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;

